var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutAdvancedAxialPrimary = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 18,
  viewBox: "0 0 29 18",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.429 1H26a2 2 0 0 1 2 2v12.2a2 2 0 0 1-2 2h-9.571V1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.429 1H26a2 2 0 0 1 2 2v6.486H16.429V1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.7 1H3a2 2 0 0 0-2 2v12.2a2 2 0 0 0 2 2h13.7V1Z"
}))));
export { SvgLayoutAdvancedAxialPrimary as ReactComponent };
export default __webpack_public_path__ + "assets/images/layout-advanced-axial-primary.svg";